import {useTranslation} from 'react-i18next';
import DateInput from '../../../../../../component/input/dateInput/DateInput';
import TimeInput from '../../../../../../component/input/dateInput/TimeInput';
import {clock} from '../../../../../../assets/symbols/symbols/Symbols.css';
import ToggledSection from './ToggleSection/ToggledSection';
import * as css from '../PricingStep/PricingStep.css';

function RedemptionValiditySection() {
    const {t} = useTranslation('subscriptions');

    return (
        <ToggledSection
            icon={clock}
            titleKey="redemptionValidity"
            toggleName="activateRedemptionValidity"
            toggleLabelKey="manualRedemptionValidity"
            fieldNames={['redemptionEndDate', 'redemptionEndTime']}
            helperTitleKey="redemptionValidityHelperTitle"
            helperContentKey="redemptionValidityHelperContent"
            toggleHelperTitleKey="redemptionValidityHelperTitle"
            toggleHelperContentKey="redemptionValidityHelperContent"
        >
            <css.inputsRow>
                <css.dateTimeColumn>
                    <DateInput 
                        name="redemptionEndDate"
                        text={t('redemptionEndDate')}
                        onChange={() => {}}
                        className={undefined} 
                        descText={undefined} 
                        readOnly={undefined} 
                        isFixed={true} 
                        icon={undefined}
                    />
                </css.dateTimeColumn>
                <css.dateTimeColumn>
                    <TimeInput 
                        name="redemptionEndTime"
                        text={t('redemptionEndTime')}
                        onChange={() => {}}
                        className={undefined} 
                        descText={undefined} 
                        readOnly={undefined} 
                        isTimestamp={true} 
                        isFixed={true} 
                        icon={undefined}
                    />
                </css.dateTimeColumn>
            </css.inputsRow>
        </ToggledSection>
    );
}

export default RedemptionValiditySection;

